module.exports = __webpack_public_path__ + "img/kk.61ee833b.svg";